import Icon from './icon';
export default {
  Icon,
  title: 'Rectangle',
  hotkey: 'r'
};